import api from './api';

// AKM POC §9.1 — İşlem Geçmişi (yalnız şirket yöneticisi) ve çalışan kartının Değişiklik Geçmişi (EM.Write).
// Okumalar api.js sözleşmesiyle: başarısız GET reject ETMEZ — çağıran `res.data?.status` ile ayırt eder.
export const AUDIT_LOG_EXPORT_URL = '/v1/audit-logs/export';
export const employeeChangeHistoryExportUrl = (employeeId) => `/v1/employees/${employeeId}/change-history/export`;

export const getAuditLogs = (params) => api.get('/v1/audit-logs', { params });
export const getAuditLog = (id) => api.get(`/v1/audit-logs/${id}`);
export const getAuditEntityTypes = () => api.get('/v1/audit-logs/entity-types');
export const verifyAuditChain = (params) => api.get('/v1/audit-logs/chain-verification', { params });
export const getEmployeeChangeHistory = (employeeId, params) => api.get(`/v1/employees/${employeeId}/change-history`, { params });
// Sekmenin ayrıntı çekmecesi — EM.Write + kapsam + kayıt türünün modülü (yönetici ucu /v1/audit-logs/{id} değil).
export const getEmployeeChangeHistoryItem = (employeeId, id) => api.get(`/v1/employees/${employeeId}/change-history/${id}`);

// Tarayıcıda üretilen dosyanın dışa aktarma olayı ayrı modülde (clientExportAudit.js — api.js'i tembel yükler).
export { logClientExport } from './clientExportAudit';
